import { T } from "../tokens";

// Maps the workbench's 4 camera modes onto what actually exists:
// - Broadcast   → 3D view, sideline preset (broadcast-style angle)
// - Tactical    → 2D top-down canvas (the existing PitchCanvas)
// - Top         → 3D view, top-down preset
// - Player Focus→ 3D view, following the selected player (needs a player selected)
export const CAMERA_MODES = [
  { key:"broadcast",   label:"Broadcast",     icon:"📹", view3D:true,  preset:"Sideline",   follow:false },
  { key:"tactical",    label:"Tactical",      icon:"👥", view3D:false, preset:null,          follow:false },
  { key:"top",         label:"Top",           icon:"⬜", view3D:true,  preset:"Top Down",    follow:false },
  { key:"playerFocus", label:"Player Focus",  icon:"👤", view3D:true,  preset:"Behind Goal", follow:true  },
];

export function CameraModeRow({ activeMode, setActiveMode, selectedPlayer }) {
  return (
    <div style={{display:"flex",gap:4,padding:"6px 10px",borderBottom:`1px solid ${T.border}`,
      background:T.surface,justifyContent:"center"}}>
      {CAMERA_MODES.map(m=>{
        const disabled = m.key==="playerFocus" && !selectedPlayer;
        const active = activeMode===m.key;
        return (
          <button key={m.key}
            disabled={disabled}
            onClick={()=>setActiveMode(m.key)}
            title={disabled ? "Select a player first" : m.label}
            style={{
              display:"flex",flexDirection:"column",alignItems:"center",gap:2,
              background:active?`${T.accent}18`:"transparent",
              border:`1px solid ${active?T.accent:T.border}`,borderRadius:8,
              color:active?T.accent:(disabled?T.textDim:T.textSec),
              padding:"6px 16px",cursor:disabled?"not-allowed":"pointer",
              fontFamily:"inherit",opacity:disabled?0.5:1,minWidth:74,
            }}>
            <span style={{fontSize:16}}>{m.icon}</span>
            <span style={{fontSize:10,fontWeight:active?700:500}}>{m.label}</span>
          </button>
        );
      })}
    </div>
  );
}

// Annotation tools — overlaid bottom-left of the viewer, matches the mockup.
export const ANNOTATION_TOOLS = [
  { key:"arrow",   label:"Arrow",     icon:"↗" },
  { key:"circle",  label:"Circle",    icon:"○" },
  { key:"space",   label:"Space",     icon:"▭" },
  { key:"note",    label:"Text Note", icon:"T" },
];

export function AnnotationToolbar({ activeTool, setActiveTool, onClear, annotationCount }) {
  return (
    <div style={{position:"absolute",bottom:10,left:10,zIndex:10,
      display:"flex",gap:4,background:"rgba(7,10,15,0.9)",
      border:`1px solid ${T.border}`,borderRadius:8,padding:5}}>
      {ANNOTATION_TOOLS.map(tool=>(
        <button key={tool.key}
          onClick={()=>setActiveTool(t=>t===tool.key?null:tool.key)}
          title={tool.label}
          style={{
            display:"flex",flexDirection:"column",alignItems:"center",gap:1,
            background:activeTool===tool.key?`${T.accent}22`:"transparent",
            border:`1px solid ${activeTool===tool.key?T.accent:"transparent"}`,
            borderRadius:6,color:activeTool===tool.key?T.accent:T.textSec,
            padding:"5px 10px",cursor:"pointer",fontFamily:"inherit",minWidth:52,
          }}>
          <span style={{fontSize:13}}>{tool.icon}</span>
          <span style={{fontSize:8.5}}>{tool.label}</span>
        </button>
      ))}
      {annotationCount > 0 && (
        <button onClick={onClear} title="Clear annotations" style={{
          display:"flex",flexDirection:"column",alignItems:"center",gap:1,
          background:"transparent",border:"1px solid transparent",borderRadius:6,
          color:T.danger,padding:"5px 10px",cursor:"pointer",fontFamily:"inherit",minWidth:44,
        }}>
          <span style={{fontSize:13}}>🗑</span>
          <span style={{fontSize:8.5}}>Clear</span>
        </button>
      )}
    </div>
  );
}
